<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeDocument" class="form-label fw-bold"
				>Type de document</label
			>
			<select
				id="typeDocument"
				class="form-select"
				name="typeDocument"
				formControlName="typeDocument"
				aria-label="Sélectionner un type de document"
				>
				<option *ngFor="let typeDocument of listTypeDocument" value="{{ typeDocument.id }}">
					{{ typeDocument.name}}
				</option>
			</select>
		</div>
	</div>

	<input type="file" class="file-upload" (change)="selectFile($event)">

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
